import { getPaymentMeansOptions } from "../constants"
import { DateiAnlage } from "./dateianlage"
import { Position } from "./position"
import { PositionMetadaten } from "./positionMetadaten"
import { PositionZeitraum } from "./positionZeitraum"
import { Rechnung } from "./rechnung"
import { SteuerDetails } from "./rechnung/rechnungsebene/steuerdetails"
import { ZuAbschlag } from "./rechnung/rechnungsebene/zuAbschlag"
import { Rechnungsdaten } from "./rechnungsdaten"
import { Rechnungsempfaenger } from "./rechnungsempfaenger"
import { Rechnungssteller } from "./rechnungssteller"
import { Rechnungstext } from "./rechnungstext"
import { Rechnungsverlauf } from "./rechnungsverlauf"
import { Steuervertreter } from "./steuervertreter"
import Ueberweisung from "./ueberweisung"
import { UrlAnlage } from "./urlanlage"
import Zahlungsbedingung from "./zahlungsbedingung"
import { Zahlungsdaten } from "./zahlungsdaten"

export class RechnungBuilder {
    private rechnung = new Rechnung()

    rechnungsdaten(rechnungsdaten: Rechnungsdaten): RechnungBuilder {
        this.rechnung.rechnungsdaten = rechnungsdaten
        return this
    }

    rechnungssteller(rechnungssteller: Rechnungssteller): RechnungBuilder {
        this.rechnung.rechnungssteller = rechnungssteller
        return this
    }

    rechnungsempfaenger(rechnungsempfaenger: Rechnungsempfaenger): RechnungBuilder {
        this.rechnung.rechnungsempfaenger = rechnungsempfaenger
        return this
    }

    zahlungsdaten(zahlungsdaten: Zahlungsdaten): RechnungBuilder {
        this.rechnung.zahlungsdaten = zahlungsdaten
        return this
    }

    addPosition(position: Position): RechnungBuilder {
        this.rechnung.positionen.push(position)
        return this
    }

    build(): Rechnung {
        return this.rechnung
    }

    fromJSON(json: Record<string, unknown>): RechnungBuilder {
        this.copyProps(json, this.rechnung)
        this.fixData(this.rechnung)

        return this
    }

    fixData(rechnung: Rechnung) {
        const found = getPaymentMeansOptions().find((p) => p.value === rechnung.zahlungsdaten.zahlungsmittelCode)?.value || null

        if (!found) {
            rechnung.zahlungsdaten.zahlungsmittelCode = getPaymentMeansOptions()[0].value
            rechnung.zahlungsdaten.ueberweisung = []
        } else {
            rechnung.zahlungsdaten.zahlungsmittelCode = found
        }
    }

    copyProps(source: any, target: any) {
        if ((target && typeof source === "string") || typeof source === "number") {
            target = source
        } else if (typeof source === "object") {
            if (!target) target = {}
            Object.keys(source).forEach((key) => {
                if (source[key]) {
                    if (Array.isArray(source[key])) {
                        //Typ ist ein Array, also leeres Array initiieren
                        if (!target[key]) target[key] = []
                        //Jedes Element aus dem source-Array durchgehen
                        source[key].forEach((entry: any, index: number) => {
                            //Extrahieren des Typs, siehe typeInstances
                            const typeKey = entry["@type"] ? entry["@type"] : key //Für Elemente mit @type-Feld, also Anlagen
                            const typeValue = this.typeInstances()[typeKey]
                            if (typeValue) {
                                target[key][index] = typeValue
                                this.copyProps(entry, target[key][index])
                            }
                        })
                        //
                    } else if (typeof source[key] !== "string" && typeof source[key] !== "number") {
                        this.copyProps(source[key], target[key])
                    } else {
                        target[key] = source[key]
                    }
                }
            })
        }
    }

    typeInstances = (): any => {
        return {
            rechnungstexte: new Rechnungstext(),
            rechnungsverlauf: new Rechnungsverlauf(),
            zahlungsbedingungen: new Zahlungsbedingung(),
            ueberweisung: new Ueberweisung(),
            positionen: new Position(),
            unterPositionen: new Position(),
            positionZeitraum: new PositionZeitraum(),
            positionMetadaten: new PositionMetadaten(),
            dateiAnlage: new DateiAnlage(),
            urlAnlage: new UrlAnlage(),
            steuerDetails: new SteuerDetails(),
            rechnungAbschlaege: new ZuAbschlag(),
            rechnungZuschlaege: new ZuAbschlag(),
            steuervertreter: new Steuervertreter(),
            //TODO: Folgende Models fehlen noch, das muss dann entsprechend ergänzt werden, wenn das Frontend um diese Models erweitert wird
            // positionAbschlaege:
            // positionZuschlaege:
        }
    }
}
